import React from "react";

const ExampleScreen = () => {
  return <h1>Example Screen</h1>;
};

export default ExampleScreen;
